import React from 'react';


const learning_26_05_2025 = () => (
  

    <div>
        learning_26_05_2025 Component
      <h1>
         Component.
      </h1>
      <p> Hello</p>
      <h2>
         Render Count:0
      </h2>
      <h3>
         Root
      </h3>
    </div>


);

learning_26_05_2025.propTypes = {};

learning_26_05_2025.defaultProps = {};

export default learning_26_05_2025;
